import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SharedService } from 'src/app/services/shared.service';
import { HeaderPagesService } from '../header-pages.service';
import { LabUserService } from '../../client-admin/clients/users/users.service';


@Component({
  selector: 'app-lab-printer',
  templateUrl: './lab-printer.component.html',
  styleUrls: ['./lab-printer.component.scss']
})
export class LabPrinterComponent implements OnInit {
  labelPrinter = null;
  printerList = [];
  searchCtrlForprinter = '';
  labInfo: any = {};
  userInfo: any = {};

  constructor(
    private dialogRef: MatDialogRef<LabPrinterComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    private headerPagesService: HeaderPagesService,
    public sharedService: SharedService,
    public labUserService: LabUserService

  ) { }

  ngOnInit(): void {
    this.getLabSetupInformation();
    this.sharedService.showPopupErrorMessage.emit({error: "", displayError: false});
  }

  ngOnDestroy() {
    this.sharedService.isPopupOpened.emit({ isPopupOpened: false});
    this.sharedService.showPopupErrorMessage.emit({error: "", displayError: false});
    this.sharedService.showErrorMessage.emit({error: "", displayError: false});
  }
  
  getLabSetupInformation() {
    this.headerPagesService.getLabSetupInformation(this.sharedService.currentUser.LabId).subscribe(res => {
      if (res) {
        this.labInfo = res;
        this.getPrinters();
      }
    });
  }

  getPrinters() {
    this.headerPagesService.getPrinters(this.labInfo.printnodeApiKey).subscribe(res => {
      if (res) {
        this.printerList = res;
        this.getUserInfo();
      }
    });
  }

  getUserInfo(){
    this.labUserService.getUserbyUserId(this.sharedService.currentUser.Id).subscribe(data => {
     this.userInfo = data;
       this.labelPrinter = Number(this.userInfo.labelPrinter);
   });
 }

  saveClick() {
    this.sharedService.showPopupErrorMessage.emit({error: "", displayError: false});
    if (!this.labelPrinter) {
      this.sharedService.showPopupErrorMessage.emit({error: "Please select Label Printer", displayError: true});
      return;
    }

    this.headerPagesService.updatePrinter(this.sharedService.currentUser.Id, this.labelPrinter).subscribe(res => {
      if (res) {
        this.dialogRef.close(true);
      }
    });

  }

  cancelClick(): void {
    this.dialogRef.close();
  }
}
